export const SHOP_GOODS_BATCH_IMPORT = 'SHOP_GOODS_BATCH_IMPORT' // 店铺商品导入（修改商品编码）
export const SHOP_GOODS_STYLE_IMPORT = 'SHOP_GOODS_STYLE_IMPORT' // 店铺商品导入（修改款式编码）
export const SHOP_GOODS_BATCH_EXPORT = 'SHOP_GOODS_BATCH_EXPORT' // 店铺商品导出
export const MY_GOODS_BATCH_DELETE = 'MY_GOODS_BATCH_DELETE' // 商品删除
export const MY_GOODS_BATCH_EXPORT = 'MY_GOODS_BATCH_EXPORT' // 商品导出
export const BATCH_ADD_DISTRIBUT = 'BATCH_ADD_DISTRIBUT' // 加入分销商品
export const FAST_REFUND_ASYNC = 'FAST_REFUND_ASYNC' // 极速退款
export const BATCH_UPDATE_PRICE = 'BATCH_UPDATE_PRICE' // 批量修改供货价
export const BATCH_UPDATE_ONE_TO_FIVE_PRICE = 'BATCH_UPDATE_ONE_TO_FIVE_PRICE' // 批量修改1-5级供货价
export const BATCH_UPDATE_BASE_PRICE = 'BATCH_UPDATE_BASE_PRICE' // 批量修改供货价
export const BATCH_ONLINE_UPDATE_TITLE = 'BATCH_ONLINE_UPDATE_TITLE' // 关联线上商品批量改标题
export const BATCH_ONLINE_UPDATE_IMAGE = 'BATCH_ONLINE_UPDATE_IMAGE' // 关联线上商品批量改主图
export const BATCH_ONLINE_UPDATE_STOCK = 'BATCH_ONLINE_UPDATE_STOCK' // 关联线上商品批量修改库存
export const BATCH_ONLINE_REMOVE = 'BATCH_ONLINE_REMOVE' // 关联线上商品批量下架
export const SHOP_ONLINE_UPDATE_FREIGHT = 'SHOP_ONLINE_UPDATE_FREIGHT' // 批量修改运费模板(拼多多)
export const CLEAN_INVALID_SPU = 'CLEAN_INVALID_SPU' // 分销商品按款清除无效分销商品
export const MY_GOODS_BATCH_DELETE_REPEAT = 'MY_GOODS_BATCH_DELETE_REPEAT' // 批量删除重复商品
export const MY_GOODS_BATCH_MERGE_REPEAT = 'MY_GOODS_BATCH_MERGE_REPEAT' // 批量合并重复商品
export const MANUALLY_PULL_ORDERS = 'MANUALLY_PULL_ORDERS' // 手工同步订单
export const BATCH_ONLINE_SINGLE_ITEM_UPDATE_STOCK = 'BATCH_ONLINE_SINGLE_ITEM_UPDATE_STOCK' // 运营分析线上单款商品批量修改库存
export const BATCH_ONLINE_UPDATE_ITEMCODE = 'BATCH_ONLINE_UPDATE_ITEMCODE' // 批量修改线上商品编码
export const BATCH_SHARE_GOODS = 'BATCH_SHARE_GOODS' // 分享erp商品导入
export const BATCH_ADD_GOODS_LABEL = 'BATCH_ADD_GOODS_LABEL' // 批量修改商品标签
export const BATCH_UPDATE_ASSIGN_SHOP = 'BATCH_UPDATE_ASSIGN_SHOP' // 微盟商品批量分配门店
export const MY_GOODS_BATCH_TO_GOODS_DRAFT = 'MY_GOODS_BATCH_TO_GOODS_DRAFT' // 自营商品批量转草稿
export const MY_GOODS_BATCH_TO_GOODS_PUBLISHED = 'MY_GOODS_BATCH_TO_GOODS_PUBLISHED' // 自营商品批量转已发布
export const BATCH_UPDATE_STOCK_SYNC_STATUS = 'BATCH_UPDATE_STOCK_SYNC_STATUS' // 批量开启/禁止库存同步
export const BATCH_MODIFY_REGULATE_PRICE = 'BATCH_MODIFY_REGULATE_PRICE' // 批量修改分销控价
export const BATCH_MODIFY_BREAK_PRICE_QUESTION = 'BATCH_MODIFY_BREAK_PRICE_QUESTION' // 批量修改破价转异常
export const BATCH_MODIFY_SHOP_PRICE = 'BATCH_MODIFY_SHOP_PRICE' // 批量修改分销控价
export const RESTORE_SHOP_PRICE = 'RESTORE_SHOP_PRICE' // 恢复价格同步任务
export const BATCH_SET_GOODS_PRIVATE_STATUS = 'BATCH_SET_GOODS_PRIVATE_STATUS' // 批量设置商品分销状态
export const EXPORT_BREAK_ORDER = 'EXPORT_BREAK_ORDER' // 导出破价订单
export const EXPORT_BREAK_GOODS = 'EXPORT_BREAK_GOODS' // 导出破价商品
export const SUPPLIER_ONLINE_ITEM_IMPORT = 'SUPPLIER_ONLINE_ITEM_IMPORT' // 店铺商品资料导入
export const OP_PAYMENT_DETAILS_EXPORT = 'OP_PAYMENT_DETAILS_EXPORT' // 中台支付单导出
export const OP_AFTER_SALES_ADDRESS_ANALYSIS = 'OP_AFTER_SALES_ADDRESS_ANALYSIS' // 售后地址使用分析
export const MY_GOODS_BATCH_LIMIT_PLATFORM = 'MY_GOODS_BATCH_LIMIT_PLATFORM' // 商品批量修改限制分销铺货平台
export const MY_GOODS_BATCH_REGULATE_PRICE_INTERCEPT = 'MY_GOODS_BATCH_REGULATE_PRICE_INTERCEPT' // 商品修改分销控价拦截上架的状态
export const DISTR_GOODS_FOR_SUPPLIER_BATCH_DELIST = 'DISTR_GOODS_FOR_SUPPLIER_BATCH_DELIST' // 分销商品(供应商商品)批量下架
export const SHOP_GOODS_BATCH_EXPORT_BY_SKU = 'SHOP_GOODS_BATCH_EXPORT_BY_SKU' // 店铺商品批量导出
export const UPDATE_PRRTNER_SHOP_GOODS_MAIN_IMAGE = 'UPDATE_PRRTNER_SHOP_GOODS_MAIN_IMAGE' // 更新小站商品主图

/** 生成退货地址策略任务 */
export const CREATE_ADDRESS_STRATEGY_TASK = 'CREATE_ADDRESS_STRATEGY_TASK'
/** 上传供应商退货地址，发货自动使用任务 */
export const UPLOAD_SUPPLIER_ADDRESS_TASK = 'UPLOAD_SUPPLIER_ADDRESS_TASK'
/** 认领矩阵号异步 */
export const MATRIX_DAREN_FOLLOW_CONFIRM_TASK = 'MATRIX_DAREN_FOLLOW_CONFIRM_TASK'
/** 达人-寄样管理-创建寄样单-异步任务 */
export const DAREN_SAMPLE_ORDER_CREATE_TASK = 'DAREN_SAMPLE_ORDER_CREATE_TASK'
/** 达人-寄样管理-Excel导入新建样品单-异步任务 */
export const DAREN_SAMPLE_ORDER_IMPORT_TASK = 'DAREN_SAMPLE_ORDER_IMPORT_TASK'
/** 达人-寄样管理-Excel补充历史样品单-异步任务 */
export const DAREN_SAMPLE_ORDER_HISTORY_IMPORT_TASK = 'DAREN_SAMPLE_ORDER_HISTORY_IMPORT_TASK'
/** 售后仅退款任务 */
export const AFTER_SALE_ONLY_REFUND_TASK = 'AFTER_SALE_ONLY_REFUND_TASK'
/** 导入文件更新开票信息 */
export const UPLOAD_PDF_INVOICE_TASK = 'UPLOAD_PDF_INVOICE_TASK'
/** 导入表格更新开票信息 */
export const UPLOAD_EXCEL_INVOICE_TASK = 'UPLOAD_EXCEL_INVOICE_TASK'
/** 售后同意退货任务 */
export const AFTER_SALE_AGREE_RETURN_TASK = 'AFTER_SALE_AGREE_RETURN_TASK'

/** 售后同意退货退款任务 */
export const AFTER_SALE_AGREE_RETURN_REFUND_TASK = 'AFTER_SALE_AGREE_RETURN_REFUND_TASK'

/** 使用供应商售后地址 */
export const APPLY_SUPPLIER_AFTERSALE_ADDRESS = 'APPLY_SUPPLIER_AFTERSALE_ADDRESS'
/** 批量启用库存同步任务 */
export const BATCH_ENABLE_STOCK_SYNC_TASK = 'BATCH_ENABLE_STOCK_SYNC_TASK'

/** 特殊价格策略添加删除商品 */
export const BATCH_MODIFY_SPECIAL_PRICE_TASK = 'BATCH_MODIFY_SPECIAL_PRICE_TASK'

/** 利润/可售检测 */
export const PROFIT_CALCULATE_TASK = 'PROFIT_CALCULATE_TASK'
